import React from 'react'
import ThumbnailPhoto from './thumbnail-photo'
import Description from './description'
import Title from './title'
import RelatedLink from './related-link'

const EventCell = ({ event }) => (
  <dd className="flex mb-1 lg:m-1">
    <ThumbnailPhoto src={event.thumbnailPhoto.small} />

    <div className="bg-black-4 lg:ml-1 flex-1 order-first lg:order-1 p-16 lg:px-24 leading-normal">
      <Title event={event} />
      <Description html={event.description} />
      <RelatedLink
        url={event.relatedUrl}
        text={event.relatedDisplayName}
      />
    </div>
  </dd>
)

export default EventCell
